/* src/app/pages/extra-pages/page403/page403.component.scss */
:host {
  align-items: center;
  background: #ff8c00;
  color: #fff;
  display: table-cell;
  height: 100%;
  padding: 1.5714286rem;
  text-align: center;
  vertical-align: middle;
  width: 10%;
}
:host h1 {
  font-size: 8rem;
  font-weight: 500;
  margin-top: 0;
  margin-bottom: 9.5rem;
  position: relative;
}
@media screen and (max-width: 767px) {
  :host h1 {
    margin-bottom: 6rem;
  }
}
:host h1:before {
  content: "\f29c";
  display: flex;
  font: normal normal normal 14px/1 FontAwesome;
  font-size: 26rem;
  justify-content: center;
  left: 0;
  line-height: 1;
  margin-top: -13rem;
  opacity: 0.2;
  position: absolute;
  right: 0;
  text-rendering: auto;
  top: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
@media screen and (max-width: 767px) {
  :host h1:before {
    font-size: 20rem;
    margin-top: -10rem;
  }
}
:host h2 {
  font-size: 2rem;
  font-weight: 500;
  margin-top: 0;
  margin-bottom: 0.5rem;
}
:host p {
  color: rgba(255, 255, 255, 0.5);
  margin: 0;
}
/*# sourceMappingURL=page403.component.css.map */
